import {
  RouteObject,
  useRoutes
} from "react-router-dom";
import { OfficialDailyFactory } from './presentation/official-daily/official-daily-factory';
import { OfficialDailyDetailFactory } from './presentation/official-daily-detail/official-daily-detail-factory';
import { PublicationsFactory } from './presentation/publications/publications-factory';
import { PublicationDetailFactory } from './presentation/publication-detail/publication-detail-factory';
import { ManagementUnitsFactory } from './presentation/management-units/management-units-factory';
import { GovernmentProjectsFactory } from './presentation/government-projects/government-projects-factory';
import { GovernmentProjectDetailFactory } from './presentation/government-project-detail/government-project-detail-factory';
import { NewsFactory } from './presentation/news/news-factory';
import { NewsDetailFactory } from './presentation/news-detail/news-detail-factory';
import { FAQFactory } from './presentation/faq/faq-factory';
import { UsefulLinksFactory } from './presentation/useful-links/useful-links-factory';
import { TermsOfUseFactory } from './presentation/terms-of-use/terms-of-use-factory';
import { PrivacyPolicyFactory } from './presentation/privacy-policy/privacy-policy-factory';
import { SearchFactory } from './presentation/search/search-factory';
import { PublicAccountsFactory } from './presentation/public-accounts/public-accounts-factory';
import { BiddingFactory } from './presentation/bidding/bidding-factory';
import { BiddingDetailFactory } from './presentation/bidding-detail/bidding-detail-factory';
import { PurchaseContractsFactory } from './presentation/purchase-contracts/purchase-contracts-factory';
import { PurchaseContractDetailFactory } from './presentation/purchase-contract-detail/purchase-contract-detail-factory';
import { AgreementsFactory } from './presentation/agreements/agreements-factory';
import { AgreementDetailFactory } from './presentation/agreement-detail/agreement-detail-factory';
import { AuditsFactory } from './presentation/audits/audits-factory';
import { AuditDetailFactory } from './presentation/audit-detail/audit-detail-factory';
import { PageNotFoundFactory } from './presentation/page-not-found/page-not-found-factory';
import ScrollToTop from "./presentation/components/shared/ScrollToTop";
import { HomeFactory } from "./presentation/home/home-factory";
import { AccessibilityFactory } from './presentation/accessibility/accessibility-factory';
import { TheCityFactory } from './presentation/the-city/the-city-factory';
import { ContactUsFactory } from './presentation/contact-us/contact-us-factory';
import { CustomPageFactory } from './presentation/custom-page';

const defaultRoutes = (): RouteObject[] => {
  var routes: RouteObject[] = [
    // Rotas standalone (domínio próprio do município)
    {
      path: "/", element: <HomeFactory />
    },
    {
      path: "/home", element: <HomeFactory />
    },
    {
      path: "/a-cidade", element: <TheCityFactory />
    },
    {
      path: "/prefeitura/unidades-gestao", element: <ManagementUnitsFactory />
    },
    {
      path: "/estrutura-administrativa", element: <ManagementUnitsFactory />
    },
    {
      path: "/contas-publicas", element: <PublicAccountsFactory />
    },
    {
      path: "/licitacoes", element: <BiddingFactory />
    },
    {
      path: "/licitacoes/detalhes/:id", element: <BiddingDetailFactory />
    },
    {
      path: "/contratos-aquisicoes", element: <PurchaseContractsFactory />
    },
    {
      path: "/contratos-aquisicoes/detalhes/:id", element: <PurchaseContractDetailFactory />
    },
    {
      path: "/convenios-repasses", element: <AgreementsFactory />
    },
    {
      path: "/convenios-repasses/detalhes/:id", element: <AgreementDetailFactory />
    },
    {
      path: "/auditorias", element: <AuditsFactory />
    },
    {
      path: "/auditoria", element: <AuditsFactory />
    },
    {
      path: "/auditorias/detalhes/:id", element: <AuditDetailFactory />
    },
    {
      path: "/diario-oficial", element: <OfficialDailyFactory />
    },
    {
      path: "/diario-oficial/:year", element: <OfficialDailyFactory />
    },
    {
      path: "/diario-oficial/detalhes/:id", element: <OfficialDailyDetailFactory />
    },
    {
      path: "/publicacoes", element: <PublicationsFactory />
    },
    {
      path: "/publicacoes/:categoryId", element: <PublicationsFactory />
    },
    {
      path: "/publicacoes/:categoryId/:subcategoryId", element: <PublicationsFactory />
    },
    {
      path: "/publicacoes/detalhes/:id", element: <PublicationDetailFactory />
    },
    {
      path: "/projetos-governamentais", element: <GovernmentProjectsFactory />
    },
    {
      path: "/projetos-governamentais/detalhes/:id", element: <GovernmentProjectDetailFactory />
    },
    {
      path: "/perguntas-frequentes", element: <FAQFactory />
    },
    {
      path: "/perguntas-respostas", element: <FAQFactory />
    },
    {
      path: "/links-uteis", element: <UsefulLinksFactory />
    },
    {
      path: "/acessibilidade", element: <AccessibilityFactory />
    },
    {
      path: "/fale-conosco", element: <ContactUsFactory />
    },
    {
      path: "/contato", element: <ContactUsFactory />
    },
    {
      path: "/noticias", element: <NewsFactory />
    },
    {
      path: "/noticias/:category/:id", element: <NewsDetailFactory />
    },
    {
      path: "/noticias/:id", element: <NewsDetailFactory />
    },
    {
      path: "/termos-de-uso", element: <TermsOfUseFactory />
    },
    {
      path: "/politica-de-privacidade", element: <PrivacyPolicyFactory />
    },
    {
      path: "/busca", element: <SearchFactory />
    },
    {
      path: "/pagina-customizada/:idArticle", element: <CustomPageFactory />
    },

    // Rotas com prefixo dinâmico de município: /:state/:city/rota
    // Usadas quando o app é hospedado como sub-app (ex: /portalmunicipio/ba/pmibirataia/)
    {
      path: "/:state/:city",
      children: [
        { path: "", element: <HomeFactory /> },
        { path: "home", element: <HomeFactory /> },
        { path: "a-cidade", element: <TheCityFactory /> },
        { path: "prefeitura/unidades-gestao", element: <ManagementUnitsFactory /> },
        { path: "estrutura-administrativa", element: <ManagementUnitsFactory /> },
        { path: "contas-publicas", element: <PublicAccountsFactory /> },
        { path: "licitacoes", element: <BiddingFactory /> },
        { path: "licitacoes/detalhes/:id", element: <BiddingDetailFactory /> },
        { path: "contratos-aquisicoes", element: <PurchaseContractsFactory /> },
        { path: "contratos-aquisicoes/detalhes/:id", element: <PurchaseContractDetailFactory /> },
        { path: "convenios-repasses", element: <AgreementsFactory /> },
        { path: "convenios-repasses/detalhes/:id", element: <AgreementDetailFactory /> },
        { path: "auditorias", element: <AuditsFactory /> },
        { path: "auditoria", element: <AuditsFactory /> },
        { path: "auditorias/detalhes/:id", element: <AuditDetailFactory /> },
        { path: "diario-oficial", element: <OfficialDailyFactory /> },
        { path: "diario-oficial/:year", element: <OfficialDailyFactory /> },
        { path: "diario-oficial/detalhes/:id", element: <OfficialDailyDetailFactory /> },
        { path: "publicacoes", element: <PublicationsFactory /> },
        { path: "publicacoes/:categoryId", element: <PublicationsFactory /> },
        { path: "publicacoes/:categoryId/:subcategoryId", element: <PublicationsFactory /> },
        { path: "publicacoes/detalhes/:id", element: <PublicationDetailFactory /> },
        { path: "projetos-governamentais", element: <GovernmentProjectsFactory /> },
        { path: "projetos-governamentais/detalhes/:id", element: <GovernmentProjectDetailFactory /> },
        { path: "perguntas-frequentes", element: <FAQFactory /> },
        { path: "perguntas-respostas", element: <FAQFactory /> },
        { path: "links-uteis", element: <UsefulLinksFactory /> },
        { path: "acessibilidade", element: <AccessibilityFactory /> },
        { path: "fale-conosco", element: <ContactUsFactory /> },
        { path: "contato", element: <ContactUsFactory /> },
        { path: "noticias", element: <NewsFactory /> },
        { path: "noticias/:category/:id", element: <NewsDetailFactory /> },
        { path: "noticias/:id", element: <NewsDetailFactory /> },
        { path: "termos-de-uso", element: <TermsOfUseFactory /> },
        { path: "politica-de-privacidade", element: <PrivacyPolicyFactory /> },
        { path: "busca", element: <SearchFactory /> },
        { path: "pagina-customizada/:idArticle", element: <CustomPageFactory /> },
      ]
    },

    // 404 - deve ser a última rota
    {
      path: "*", element: <PageNotFoundFactory />
    },
  ];

  return routes;
}

function App() {
  let routes = useRoutes(
    defaultRoutes()
  );

  return (
    <>
      <ScrollToTop />
      {routes}
    </>
  );
}

export default App;
